<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowledgePage" id="ack01">
<a id="pageviii">
</a><a id="pageix">
<h2 class="acknowledgeHead"><span class="bold"><em class="italic">Acknowledgments</em></span></h2>
<p class="acknowledgeText">For Nate…</p>
<p class="acknowledgeText">Thank you for the perfect wedding—peaceful, joyous, and loving.<br/> I love you more every day.</p>
</a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781439164341_ack01.vue?5f1969a2